import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { BaseService } from '../../templates/services/base-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Core2Config } from '../../utils/core2-config';
import { getHttpHeader } from '../../utils/http-header.factory';
import { PGWTransactionInquiryContainerModel } from '../../models/pgw-transaction/pgw-transaction-inquiry-container.model';

@Injectable({
  providedIn: 'root'
})
export class PGWTransactionInquiryService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/query-by-refno';

  constructor(protected readonly http: HttpClient) {}

  public getByRefno(refNo: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<PGWTransactionInquiryContainerModel>>{
    return this.http.get<ApiResponseModel<PGWTransactionInquiryContainerModel>>(`${ api_domain_url }${ this.apiUrl }?refNo=${ refNo }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
